module.exports = __webpack_public_path__ + "img/H2.6adf998f.png";